import { render, staticRenderFns } from "./TeachersPIP.vue?vue&type=template&id=13342214&scoped=true&"
import script from "./TeachersPIP.vue?vue&type=script&lang=js&"
export * from "./TeachersPIP.vue?vue&type=script&lang=js&"
import style0 from "./TeachersPIP.vue?vue&type=style&index=0&id=13342214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13342214",
  null
  
)

export default component.exports